import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Header.tsx");
